import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        redirect: {name: 'login'}
    }, {
        path: "/public",
        component: () => import("../views/public/Public.vue"),
        children: [
            {
                path: "",
                redirect: {name: "login"},
            }, {
                path: "login",
                name: "login",
                component: () => import("../views/public/login/Login.vue"),
                meta: {
                    title: 'Prihlásenie',
                }
            }, {
                path: "login-verification",
                name: "verification",
                component: () => import("../views/public/login/Verification.vue"),
                meta: {
                    title: 'Overenie',
                }
            }, {
                path: "lost-password",
                name: "lostPassword",
                component: () => import("../views/public/login/LostPassword.vue"),
                meta: {
                    title: 'Stratené heslo',
                }
            }, {
                path: "reset-password/:id/:hash",
                name: "resetPassword",
                component: () => import("../views/public/login/ResetPassword.vue"),
                meta: {
                    title: 'Obnova hesla',
                }
            }
        ]
    }, {
        path: "/",
        component: () => import("../views/private/Private.vue"),
        children: [
            {
                path: "",
                redirect: {name: "dashboard"},
            }, {
                path: "dashboard",
                name: "dashboard",
                component: () => import("../views/private/dashboard/Dashboard.vue"),
                meta: {
                    title: 'Prehľad',
                }
            }, {
                path: "assets",
                name: "assets",
                component: () => import("../views/private/assets/Assets.vue"),
                meta: {
                    title: 'Majetok',
                }
            }, {
                path: "transactions",
                component: () => import("../views/private/transactions/Transactions.vue"),
                children: [
                    {
                        path: "",
                        redirect: {name: "transactions"},
                    }, {
                        path: "list",
                        name: "transactions",
                        component: () => import("../views/private/transactions/List.vue"),
                        meta: {
                            title: 'Transakcie',
                        }
                    }, {
                        path: "trades",
                        name: "trades",
                        component: () => import("../views/private/transactions/Trades.vue"),
                        meta: {
                            title: 'Obchody',
                        }
                    }, {
                        path: "conversions",
                        name: "conversions",
                        component: () => import("../views/private/transactions/Conversions.vue"),
                        meta: {
                            title: 'Konverzie',
                        }
                    }
                ]
            }, {
                path: "profile",
                name: "profile",
                component: () => import("../views/private/profile/Profile.vue"),
                meta: {
                    title: 'Profil',
                }
            }, {
                path: "messages",
                component: () => import("../views/private/messages/Messages.vue"),
                children: [
                    {
                        path: "",
                        redirect: {name: "messages"},
                    }, {
                        path: "list",
                        name: "messages",
                        component: () => import("../views/private/messages/List.vue"),
                        meta: {
                            title: 'Správy',
                        }
                    }, {
                        path: ":id",
                        name: "message",
                        component: () => import("../views/private/messages/Message.vue"),
                        meta: {
                            title: 'Správy',
                        }
                    }, {
                        path: "exports",
                        name: "exports",
                        component: () => import("../views/private/messages/Exports.vue"),
                        meta: {
                            title: 'Výpisy',
                        }
                    }
                ]
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
